import styled from "styled-components";

export const TagCompoent = styled.div`
    font-size: 10px;
    color: #FFFFFF;
    background-color: ${props => props.color};
    padding-top: 3px;
    padding-bottom: 3px;
    border-radius: 100px;
    width: 90%;
    align-self: 'center';
    font-weight: 600;
`